export default class extends HTMLElement {
  initalRender = true;
  connectedCallback() {
    console.log("connectedCallback");
    console.log(this);
    const sendEmailCheckbox = this.closest("form").querySelector(
      ".email-form-checkbox",
    );
    console.log(sendEmailCheckbox);
    if (sendEmailCheckbox) {
      sendEmailCheckbox.addEventListener(
        "change",
        this.toggleEmailOptions.bind(this),
      );
      this.toggleEmailOptions({ target: sendEmailCheckbox });
    }
  }

  toggleEmailOptions(event) {
    console.log("toggleEmailOptions");
    const isChecked = event.target.checked;
    console.log(isChecked);
    console.log(this);
    const editMessage = this.querySelector(".email-form-edit-message");
    const buttonText = this.querySelector("[data-email-form-button-text]");
    const messageField = this.querySelector(".email-form-message");

    console.log("editMessage", editMessage);
    if (editMessage) {
      editMessage.style.display = isChecked ? "block" : "none";
    }

    if (buttonText) {
      buttonText.textContent = isChecked ? "Send" : "Add Recipients";
    }

    // Reminders only make sense when the invitation email goes out.
    const reminders = this.querySelector(".email-form-reminders");
    if (reminders) {
      const remindersCheckbox = reminders.querySelector('input[type="checkbox"]');
      reminders.classList.toggle("opacity-50", !isChecked);
      if (remindersCheckbox) {
        remindersCheckbox.disabled = !isChecked;
      }
    }


    if (
      messageField &&
      !isChecked &&
      !messageField.classList.contains("hidden")
    ) {
      messageField.classList.add("hidden");
    }

    if (
      messageField &&
      isChecked &&
      messageField.classList.contains("hidden")
    ) {
      if (this.initalRender) {
        this.initalRender = false;
        return;
      }
      messageField.classList.remove("hidden");
      editMessage.style.display = "none";

    }
  }

  disconnectedCallback() {
    const sendEmailCheckbox = this.closest("form").querySelector(
      'input[name="submission[send_email]"]',
    );
    if (sendEmailCheckbox) {
      sendEmailCheckbox.removeEventListener(
        "change",
        this.toggleEmailOptions.bind(this),
      );
    }
  }
}
